var exports = {
  "K": "GuildJoinMessage.module__icon___YkoyZm",
};

module.exports = exports;
